import { cn } from '@neo/lib/utils'

interface AnimatedGradientTextProps {
  children: React.ReactNode
  className?: string
  speed?: number
  colorFrom?: string
  colorTo?: string
}

export const AnimatedGradientText = ({
  children,
  className = '',
  speed = 1.5,
  colorFrom = 'hsl(var(--brand-text))',
  colorTo = 'hsl(var(--brand-text))',
}: AnimatedGradientTextProps) => (
  <span
    className={cn(
      'inline-block bg-gradient-to-r bg-clip-text text-transparent animate-gradient-shift',
      className,
    )}
    style={{
      backgroundImage: `linear-gradient(90deg, ${colorFrom}, ${colorTo}, ${colorFrom})`,
      backgroundSize: '200% 100%',
      animation: `gradient-shift ${2 / speed}s ease-in-out infinite`,
    }}
  >
    {children}
  </span>
)
